export default "__VITE_ASSET__95c57d32__"